"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentralPermission = void 0;
var SentralPermission;
(function (SentralPermission) {
    SentralPermission["USER_MANAGEMENT"] = "users";
    SentralPermission["MEMBER_MANAGEMENT"] = "members";
})(SentralPermission = exports.SentralPermission || (exports.SentralPermission = {}));
//# sourceMappingURL=userSentral.js.map